import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index";
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import { OrderingListItemViewModel, OrderingListViewModel, FavoriteListItem, FavoriteList, FavoriteListViewModel, FavoriteListItemViewModel } from 'Api/CoreApi';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { ProductlistWithFavoriteList } from 'Store/FavoriteList';
import OrderingListMixin from 'Mixins/OrderingListMixin';

@Component({})
export default class ProductComponent extends mixins(BaseComponent, OrderingListUserMixin,OrderingListMixin) {
    
    @Prop()
    public productKey: string;
    
    async created() {
      
    }
    
    
    get hide(): boolean{
        return false;
        //TODO: ??NEVER HIDE Products - this is to HARD TO maintains
        // //never hide on webshop!
        if(!this.scopeIsOrderingList) return false;

        if(this.isAllowed){
            return this.scopeIsOrderingList && this.item == null;
        }  else{      
            //standard user customer agreement is from other source - why we need to make this check
            if(this.customerAgreements && this.customerAgreements.includes(this.productKey))
            {
                return false;
            }
            //standard user presentation
            return this.scopeIsOrderingList && !this.favoriteListItem;
        }
        return false;
    }
    
    
    //fadeout - if product is deleted from list view and/or some advanced conditions
    get fadeout(): boolean{
        //if advanced view - fadeout customer agreement products if not avaible on current user list
        //no need to check if employee - as these are not permitted to delete items
        if(this.isAllowed){
            if(this.scopeIsOrderingList)
            {
                if(this.item == null) return false;

                //fadeout not avaible customer agreement products
                return this.item && this.item.isCustomerAgreement && !this.item.isAvailable;
            }
            //fadeout customer agreement on WHOLE SHOP, - if not avaible on current list
            return this.item && this.item.isCustomerAgreement && !this.item.isAvailable;
        }
        else{
            //standard user - fadeout deleted favoritelist items on list view and sortiment
            return this.scopeIsOrderingList && !this.favoriteListItem;
        }
        return false;
    }
    
    
    
    get favoriteListItem(): boolean {
        //hack to trigger re-rendering of component
        var test= store.state.favoriteList.detectChanges;
        if(this.favoriteLists && this.favoriteLists.has(this.productKey)) 
        return this.favoriteLists.get(this.productKey).favoriteListIds.length > 0;
        return false;
    }
    
    get favoriteLists() : Map<string, ProductlistWithFavoriteList>{
        return store.getters.favoriteList.productMapToFavoriteLists;
    }
    
    get item(): OrderingListItemViewModel
    {
        return this.list && this.list && this.list.items && this.list.items.find(x => x.productKey == this.productKey);
    }
    
    
    get list() : OrderingListViewModel{
        return store.state.orderingList.currentOrderingList;
    }
    
    get customerAgreements(){
        return store.state.customerAgreement.list;
    }
    
}

Vue.component('product', ProductComponent);